<template>
  <div>
    <v-select
      :items="selectbox"
      outlined
      background-color="white"
      v-model="data.Records[0].value"
      :label="label"
    >
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    record: Object,
    label: String,
    init: String,
    selectbox: Array,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: this.init, form_id: 0, form_type: 2 }],
      },
      rules: { required: (value) => !!value || "必須項目です" },
    };
  },
  async mounted() {},
};
</script>

<style></style>
